module.exports = __webpack_public_path__ + "static/media/phone-icon.3468c8b0.svg";